// extracted by mini-css-extract-plugin
module.exports = {"exchange_row":"ExchangeHeader_exchange_row__1Tykk","value":"ExchangeHeader_value__1JkrT","amount":"ExchangeHeader_amount__3tWIo","token":"ExchangeHeader_token__1PI0M"};